// extracted by css-extract-rspack-plugin
export default {"root":"fvAd_","visualization":"CnaZz"};